// extracted by mini-css-extract-plugin
export default {"container":"ChooseTag_container__5VzrJ","tags":"ChooseTag_tags__Airh8"};